export { default as OwnerPostsPage } from './OwnerPostsPage'
